import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { emphasize } from '@mui/material';

export default styled(Link)(({ theme }) => {
  const { palette } = theme;
  const primaryColor = palette.primary.main;

  // Custom styles
  const customStyles = () => ({
    color: primaryColor,
    textDecoration: 'underline!important',
    '&:hover': {
      color: `${emphasize(primaryColor, 0.2)} !important`
    }
  });

  return {
    ...customStyles()
  };
});
